import * as React from "react";
import { ASSORTMENTS } from "constants/integration/assortments";
import { FormatMessage as FormatMessageComponent } from "react-globalize";
import Reminders from "components/product-media/components/reminders";

interface IProps {
    items: string[];
    wasUpdated: boolean;
}

export const SummarizeColumnsCreated: React.FC<IProps> = ({ items, wasUpdated }) => {
    const title = wasUpdated ? (
        <FormatMessageComponent
            path="[strong]|count|[strong] new attributes have been [strong]added:[strong]"
            elements={{ strong: <b /> }}
            variables={{
                count: items.length,
            }}
        />
    ) : (
        <FormatMessageComponent path="New door attributes to be [strong]added:[strong]" elements={{ strong: <b /> }} />
    );
    return (
        <Reminders
            title={title}
            shouldUseCurrentColor
            dataTestList={ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.SUMMARIZE_COLUMN.CREATED.LIST}
            dataTestTitle={ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.SUMMARIZE_COLUMN.CREATED.TITLE}
        >
            {items.map((col, index) => (
                <li
                    key={`${col}-${index}`}
                    data-test={`${ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.SUMMARIZE_COLUMN.CREATED.ITEM}-${index}`}
                >
                    {col}
                </li>
            ))}
        </Reminders>
    );
};
